import { useEffect, useState } from "react";
import { browserStorage } from "~/libs/localforage";
import { initialState, FileSettingsContext, FileSettingsState, SearchFilters } from "./file-settings-context";
import type { FC, ReactNode } from "react";
interface FileSettingsProviderProps {
  children?: ReactNode;
}
export const FileSettingsProvider: FC<FileSettingsProviderProps> = props => {
  const {
    children
  } = props;
  const [state, setState] = useState<FileSettingsState>(initialState);
  useEffect(() => {
    browserStorage.fileSettings.get().then(r => {
      setState(r ? JSON.parse(r) : initialState);
    }).catch(err => console.log({
      err
    }));
  }, []);
  const handleHideProcessModelOpen = async () => {
    const newState = {
      ...state,
      hideProcess: {
        ...state.hideProcess,
        isModelOpen: true
      }
    };
    await handleStateChange(newState);
  };
  const handleHideProcessModelClose = async () => {
    const newState = {
      ...state,
      hideProcess: {
        ...state.hideProcess,
        isModelOpen: false
      }
    };
    await handleStateChange(newState);
  };
  const handleHideProcess = async (processId: string) => {
    const vals = state.hideProcess?.selectedProcesses ?? [];
    const newState = {
      ...state,
      hideProcess: {
        ...state.hideProcess,
        selectedProcesses: [...vals, processId]
      }
    };
    await handleStateChange(newState);
  };
  const handleUnhideProcess = async (processId: string) => {
    const vals = state.hideProcess?.selectedProcesses ?? [];
    if (vals.length === 0) return;
    const newState = {
      ...state,
      hideProcess: {
        ...state.hideProcess,
        selectedProcesses: vals.filter(v => v !== processId)
      }
    };
    await handleStateChange(newState);
  };
  const handleFileSearchOpen = async () => {
    const newState = {
      ...state,
      fileSearch: {
        ...state.fileSearch,
        isModelOpen: true
      }
    } as unknown as FileSettingsState;
    await handleStateChange(newState);
  };
  const handleFileSearchClose = async () => {
    const newState = {
      ...state,
      fileSearch: {
        ...state.fileSearch,
        isModelOpen: false
      }
    } as unknown as FileSettingsState;
    await handleStateChange(newState);
  };
  const handleUpdateSearch = async (added: SearchFilters) => {
    const newState = {
      ...state,
      fileSearch: {
        ...state.fileSearch,
        [added.field]: added.search
      }
    } as unknown as FileSettingsState;
    await handleStateChange(newState);
  };
  const handleClearSearch = async () => {
    const newState = {
      ...state,
      fileSearch: {
        ...state.fileSearch,
        assignees: [],
        clients: [],
        agents: [],
        creators: [],
        orderStatuses: [],
        paymentStatuses: [],
        files: [""],
        invoices: [""]
      }
    } as unknown as FileSettingsState;
    await handleStateChange(newState);
  };
  const handleFileHistorySearchOpen = async () => {
    const newState = {
      ...state,
      fileHistorySearch: {
        ...state.fileHistorySearch,
        isModelOpen: true
      }
    } as unknown as FileSettingsState;
    await handleStateChange(newState);
  };
  const handleFileHistorySearchClose = async () => {
    const newState = {
      ...state,
      fileHistorySearch: {
        ...state.fileHistorySearch,
        isModelOpen: false
      }
    } as unknown as FileSettingsState;
    await handleStateChange(newState);
  };
  const handleUpdateFileHistorySearch = async (added: SearchFilters) => {
    const newState = {
      ...state,
      fileHistorySearch: {
        ...state.fileHistorySearch,
        [added.field]: added.search
      }
    } as unknown as FileSettingsState;
    await handleStateChange(newState);
  };
  const handleClearFileHistorySearch = async () => {
    const newState = {
      ...state,
      fileSearch: {
        ...state.fileSearch,
        assignees: [],
        clients: [],
        agents: [],
        creators: [],
        orderStatuses: [],
        paymentStatuses: [],
        files: [""],
        invoices: [""]
      }
    } as unknown as FileSettingsState;
    await handleStateChange(newState);
  };
  const handleStateChange = async (state: FileSettingsState) => {
    await browserStorage.fileSettings.set(JSON.stringify(state));
    setState(state);
  };
  return <FileSettingsContext.Provider value={{
    ...state,
    handleHideProcessModelOpen,
    handleHideProcessModelClose,
    handleHideProcess,
    handleUnhideProcess,
    handleFileSearchOpen,
    handleFileSearchClose,
    handleUpdateSearch,
    handleClearSearch,
    handleFileHistorySearchOpen,
    handleFileHistorySearchClose,
    handleUpdateFileHistorySearch,
    handleClearFileHistorySearch
  }} data-sentry-element="unknown" data-sentry-component="FileSettingsProvider" data-sentry-source-file="file-settings-provider.tsx">
			{children}
		</FileSettingsContext.Provider>;
};